import { UiDivider } from '@experiences/ui-common/UiDivider';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import { Collapse } from '@mui/material';
import {
    createStyles,
    makeStyles,
} from '@mui/styles';
import clsx from 'clsx';
import React, {
    useMemo,
    useState,
} from 'react';
import { useIntl } from 'react-intl';

import { useParams } from '../../container/Router';
import {
    PlatformName,
    useSignupType,
} from '../../util/hooks/SignupType';
import Providers from '../../util/interfaces/provider';
import UiProviderButton from '../UiProviderButton/UiProviderButton';
import { UiSocialButton } from '../UiSocialButton';
import SignupFormComponent from './LegacySignupFormComponent';
import { SimpleSignupFormComponent } from './SimpleSignupFormComponent';

const useStyles = makeStyles((theme) =>
    createStyles({
        flex: {
            display: 'flex',
            flexDirection: 'column',
        },
        standardWidth: { width: '360px' },
        spacer: { margin: '16px 0' },
        button: {
            marginTop: '16px',
            borderColor: `${theme.palette.semantic.colorBorderDeEmp} !important`,
        },
    }),
);

export const SignupOptionsComponent = ({ useLegacyForm = false }) => {
    const classes = useStyles();
    const { formatMessage: translate } = useIntl();

    const [ showForm, setShowForm ] = useState(false);
    const { isSignupType } = useSignupType();
    const params = useParams();

    const isBusiness = useMemo(() => {
        const isAutomationHub = isSignupType(PlatformName.AutomationHub) || isSignupType(PlatformName.UiAutomationHub);
        return (
            isSignupType(PlatformName.UiEnterprise) || (isAutomationHub && params.product_name === 'UiPath Automation Cloud')
        );
    }, [ isSignupType, params.product_name ]);

    return (
        <div className={classes.flex}>
            <div className={classes.flex}>
                <UiProviderButton
                    provider={Providers.Google}
                    showOptions={false}
                    isSignup
                    centered />
                <UiProviderButton
                    provider={Providers.Microsoft}
                    showOptions={false}
                    isSignup
                    centered />
            </div>
            <UiDivider className={clsx(classes.standardWidth, classes.spacer)} />
            <Collapse in={showForm}>
                {useLegacyForm ? <SignupFormComponent /> : <SimpleSignupFormComponent isBusiness={isBusiness} />}
            </Collapse>
            <Collapse in={!showForm}>
                <UiSocialButton
                    icon={<MailOutlineIcon
                        fontSize="small"
                        color="action" />}
                    fullWidth
                    onClick={() => setShowForm(true)}
                    data-cy="authorize-with-email"
                    className={classes.button}
                    centered
                >
                    {translate({ id: 'CONTINUE_WITH_EMAIL' })}
                </UiSocialButton>
            </Collapse>
        </div>
    );
};
